const efpaConfig = {
  BASE_URL: process.env.GATSBY_BASE_URL,
  PROXY_URL: process.env.GATSBY_PROXY_URL,
  DEFAULT_USERNAME: process.env.GATSBY_DEFAULT_USERNAME,
  DEFAULT_PASSWORD: process.env.GATSBY_DEFAULT_PASSWORD,
  SERVER_URL_FILES: process.env.GATSBY_SERVER_URL_FILES,
  SERVER_URL_FILES_WEB: process.env.GATSBY_SERVER_URL_FILES_WEB,
  SPAIN_PK: parseInt(process.env.GATSBY_SPAIN_PK),
  URL_PRICES_EFP: process.env.GATSBY_URL_PRICES_EFP,
  URL_PRICES_EFA: process.env.GATSBY_URL_PRICES_EFA,
  URL_PRICES_NIVELII: process.env.GATSBY_URL_PRICES_NIVELII,
  URL_PRICES_EIP: process.env.GATSBY_URL_PRICES_EIP,
  URL_PRICES_EIA: process.env.GATSBY_URL_PRICES_EIA,
  URL_PRICES_ESG: process.env.GATSBY_URL_PRICES_ESG,
  CNMV_LINK: process.env.GATSBY_CNMV_LINK,
  PRIVACY_POLICIES_URL: process.env.GATSBY_PRIVACY_POLICIES_URL || "",
  GATSBY_ENTERPRISE_BBVA_PKS:
    process.env.GATSBY_ENTERPRISE_BBVA_PKS &&
    process.env.GATSBY_ENTERPRISE_BBVA_PKS.split(","),
  GATSBY_LOGO_PATH: process.env.GATSBY_LOGO_PATH || "/imgs/logo.gif",
};

export default efpaConfig;
